/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisibilityVisitDto } from '../../models/visibility-visit-dto';

export interface GetVisibilityVisits$Params {
}

export function getVisibilityVisits(http: HttpClient, rootUrl: string, params?: GetVisibilityVisits$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VisibilityVisitDto>>> {
  const rb = new RequestBuilder(rootUrl, getVisibilityVisits.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VisibilityVisitDto>>;
    })
  );
}

getVisibilityVisits.PATH = '/api/company/visibility/visits';
